import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectFavoriteReports,
  selectRecentReports,
  selectReport,
  selectReportEdition,
  selectReportEditions,
  selectReports
} from 'redux/selectors/Reports'

/**
 * Get a specific report by ID.
 * @param reportId - Report ID
 * @returns TReport | null
 */
export const useReport = (reportId: string | null) => {
  return useSelector((state: ApplicationState) => selectReport(state, reportId))
}

/**
 * Get all reports.
 * @returns Array of all reports
 */
export const useReports = () => {
  return useSelector(selectReports)
}

/**
 * Get all favorite reports sorted alphabetically.
 * @returns Array of favorite reports
 */
export const useFavoriteReports = () => {
  return useSelector(selectFavoriteReports)
}

/**
 * Get recently visited reports (max 5, sorted by date desc).
 * @returns Array of recently visited reports
 */
export const useRecentReports = () => {
  return useSelector(selectRecentReports)
}

/**
 * Get all editions for a specific report.
 * @param reportId - Report ID
 * @returns Array of TReportEdition
 */
export const useReportEditions = (reportId: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectReportEditions(state, reportId)
  )
}

/**
 * Get a specific edition by ID.
 * @param editionId - Edition ID
 * @returns TReportEdition | null
 */
export const useReportEdition = (editionId: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectReportEdition(state, editionId)
  )
}
